var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5688 8.50016C15.5688 9.42841 15.386 10.3476 15.0308 11.2052C14.6755 12.0627 14.1549 12.842 13.4985 13.4983C12.8421 14.1547 12.0629 14.6754 11.2053 15.0306C10.3477 15.3858 9.42858 15.5686 8.50033 15.5686C7.57209 15.5686 6.65293 15.3858 5.79534 15.0306C4.93776 14.6754 4.15853 14.1547 3.50216 13.4983C2.84579 12.842 2.32513 12.0627 1.96991 11.2052C1.61468 10.3476 1.43185 9.42841 1.43185 8.50016C1.43185 6.62549 2.17656 4.82759 3.50216 3.50199C4.82776 2.1764 6.62566 1.43168 8.50033 1.43168C10.375 1.43168 12.1729 2.1764 13.4985 3.50199C14.8241 4.82759 15.5688 6.62549 15.5688 8.50016ZM16.9823 8.50016C16.9823 13.1842 13.1848 16.9825 8.49992 16.9825C3.81591 16.9825 0.0175781 13.1842 0.0175781 8.50016C0.0175781 3.81616 3.81591 0.0178223 8.49992 0.0178223C13.1839 0.0178223 16.9823 3.81533 16.9823 8.50016ZM11.8175 9.16401C11.8732 9.13356 11.9198 9.08866 11.9522 9.03403C11.9846 8.9794 12.0017 8.91705 12.0017 8.85353C12.0017 8.79001 11.9846 8.72766 11.9522 8.67302C11.9198 8.61839 11.8732 8.5735 11.8175 8.54305L6.72528 5.7714C6.67144 5.74212 6.61093 5.72732 6.54966 5.72846C6.48839 5.72959 6.42847 5.74662 6.37576 5.77788C6.32305 5.80914 6.27937 5.85355 6.24899 5.90677C6.21861 5.95999 6.20257 6.02019 6.20245 6.08147V11.6256C6.20245 11.8936 6.48943 12.0643 6.72528 11.9357L11.8175 9.16401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.346cb952e8c0691933d2ba1ebfabd528.svg";
export { ForwardRef as ReactComponent };